// Beta-access gate client helpers (L0-U5 -- ADR 0024 D1 private-beta gate).
//
// The landing page asks visitors for a shared beta code; this module verifies
// it server-side (the code never ships in the JS bundle) and remembers the
// unlocked state in localStorage so the gate is shown once per browser. The
// gate is a UX funnel, NOT a security boundary -- Auth0 + the local users row
// remain the real access control, so a tampered localStorage flag only reveals
// the sign-in button, never an account.

const BETA_UNLOCK_KEY = "beta_unlocked";

function resolveBaseUrl(): string {
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return "";
}

export function isBetaUnlocked(): boolean {
  try {
    return window.localStorage.getItem(BETA_UNLOCK_KEY) === "true";
  } catch {
    // localStorage can throw in private-mode / disabled-storage browsers.
    return false;
  }
}

export function setBetaUnlocked(): void {
  try {
    window.localStorage.setItem(BETA_UNLOCK_KEY, "true");
  } catch {
    // Best-effort: if storage is unavailable the gate simply re-prompts.
  }
}

// POST the code to the public endpoint; returns true only on an explicit
// {valid: true}. Any network/parse failure resolves false so the caller shows
// the same "try again" path rather than throwing.
export async function verifyBetaCode(code: string): Promise<boolean> {
  try {
    const response = await fetch(`${resolveBaseUrl()}/api/public/beta-access`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ code }),
    });
    if (!response.ok) {
      return false;
    }
    const data: unknown = await response.json();
    return (
      typeof data === "object" &&
      data !== null &&
      (data as { valid?: unknown }).valid === true
    );
  } catch {
    return false;
  }
}
